module.exports = __webpack_public_path__ + "static/oes_disk.c533298c.png";